export function MomentPipe(moment) {
  return function (dateString, format) {
    return moment(dateString).format(format);
  };
}

MomentPipe.$inject = ['moment'];
